import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, useQueryClient } from 'react-query';
import { CompanyTheme } from 'shared/contexts/theme-provider';
import { companyService } from 'ogp/services';

export const useUpdateCompanyTheme = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (theme: CompanyTheme) => {
      return await companyService.updateCompanyTheme(theme);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.ownCompanyTheme() });
      },
    }
  );
};
